import './featured-list.scss';

import { defineComponent } from 'vue'

import { DELETE_CARD } from '@skinsoft/events'
import { FeaturedCard } from '../featured-card'

export const FeaturedList = defineComponent({
    components: {
        sFeaturedCard: FeaturedCard,
    },
    props: ['emptyMessage', 'featureds', 'title', 'customCard', 'customCardProps'],
    template: require('./featured-list.html'),
    data() {
        return {
            DELETE_CARD,
        }
    },
})
